import styles from "./banner.module.css";

export type BannerProps = {
  srcDesk: string;
  srcMobile: string;
  alt: string;
};

export const Banner = ({ srcDesk, srcMobile, alt }: BannerProps) => {
  return (
    <div className={styles.Banner}>
      <picture>
        <source
          data-testid="image-source-tag"
          media="(max-width: 900px)"
          srcSet={srcMobile}
        />
        <img src={srcDesk} alt={alt} className={styles.BannerImage} />
      </picture>
    </div>
  );
};
